var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success","max-height":"32px","depressed":""},on:{"click":function($event){return _vm.addTenant()}}},[_vm._v(" 追加 ")])}
var staticRenderFns = []

export { render, staticRenderFns }